import profile from "../other/profile";
import additionalCost from "../shared/additionalCost";
import additionalDocument from "../shared/additionalDocument";
import address from "../shared/address";
import bill from "../shared/bill";
import contact from "../shared/contact";
import discount from "../shared/discount";
import document from "../shared/document";
import notes from "../shared/notes";
import payment from "../shared/payment";
import paymentDocument from "../shared/paymentDocument";
import rentalObject from "../shared/rentalObject";
import companyreport from "../shared/companyreport";

const operatingCost = `
    accountingPositions {
        apportionable
        correctDistributerType
        distributerType
        distributerTypeOther
        duplicate {
            critical
            id
        }
        explanation
        id
        positionId
        singleDistributor {
            diff
            landlord
            our
        }
        tenantCost {
            diff
            landlord
            our
        }
        title
        totalCosts
        totalDistributor {
            diff
            landlord
            our
        }
    }
    additionalCosts {
        ${additionalCost}
    }
    additionalDocuments {
        ${additionalDocument}
    }
    advanceHeatingCostPayment {
        landlord
        our
        diff
    }
    advanceOperatingCostPayment {
        landlord
        our
        diff
    }
    agreement {
        ${document}
    }
    balance {
        landlord
        our
        diff
    }
    balanceType
    bankAccount {
        iban
        id
        name
    }
    bankAccountId
    billReportBasePrice
    billingAddress {
        ${address}
    }
    billingAddressId
    billings {
        ${bill}
    }
    caseClosedType
    caseHeros
    caseId
    cid
    coldWaterPerUsage
    created
    debtorLawyer {
        ${contact}
        caseNumber
    }
    discountId
    discount {
        ${discount}
    }
    estimationJustification
    externalCompanyReports {
        ${companyreport}
    }
    heatingCostReport {
        ${companyreport}
    }
    operatingCostReport {
        ${companyreport}
    }
    finished
    futureBaseRent
    futureHeatingCosts
    futureOperatingCosts
    futureTotalRent
    heatingCostPerUsage
    id
    incomingPayments {
        ${payment}
    }
    indebtedToLandlord
    inputCompleted
    inputOverview {
        ${document}
    }
    landlordDiff
    lastMail
    lastStatusChange
    letterArrival
    missingDocuments
    modified
    monitions {
        ${paymentDocument}
    }
    nextDeadline
    ${notes}
    operationalCosts {
        ${document}
    }
    operatingCostReportPages {
        id
        category
        created
        creator
        number
        parsedPageNumber
    }
    outgoingPayments {
        ${payment}
    }
    ownerSub
    partitionKey
    path
    paymentDue
    paymentInfo {
        iban
        id
        name
    }
    preparedCaseForLambdas
    productType
    profile {
        ${profile}
    }
    readable
    referrer {
        id
        referringPartner
    }
    rentalObject {
        ${rentalObject}
    }
    rentalObjectId
    report {
        ${document}
    }
    reportBasePrice
    requestsPayments {
        ${paymentDocument}
    }
    resubmissions {
        author
        message
        remember
    }
    sales
    signatures {
        id
        signature
        tenantId
    }
    status
    storedBankAccount {
        iban
        id
        name
    }
    storedBillingAddress {
        ${address}
    }
    storedDiscount {
        ${discount}
    }
    storedProfile {
        ${profile}
    }
    storedRentalObject {
        ${rentalObject}
    }
    totalBelegEinsicht
    totalDiff
    type
    usageEstimated
    warmWaterPartFormula
    warmWaterPartFormulaJustification
    warmWaterPerUsage
    warning
    warnings {
        field {
            id
            name
        }
        code
        message
    }
    year
`;

export default operatingCost;
